export default {
  organization: (state) => state.organization,
  organizations: (state) => state.organizations,
  examineOrganization: (state) => state.examineOrganization,
  found: (state) => state.found,
  pager: (state) => state.pager,
  isChecked: (state) => state.isChecked,
  members: (state) => state.members,
  foundMembers: (state) => state.foundMembers,
  tags: (state) => state.tags,
}
